import React, {ReactElement} from 'react';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  CardActions
} from '@customink/pigment-react';
import {StoreProduct} from '../../models/storeProduct';
import {Product, Color} from '../../models/product';
import ProductColorSwatch from '../ProductColorSwatch';
import {useAppSelector} from '../../hooks';
import {formatCurrency} from '../../utils/helpers';
import {selectProductColorMap} from '../../slices/storesSlice';

type StoreProductsListProps = {
  products: StoreProduct[];
  mmsProducts: Product[];
};

function validTrim(val: {red: number; blue: number; green: number}) {
  return typeof val?.red === 'number';
}

const productColors = (c: Color) => {
  const hasTrimRgb = validTrim(c.trim_rgb);
  return (
    <ProductColorSwatch
      rgb={c.rgbs[0]}
      productId={null}
      trimRgb={hasTrimRgb ? c.trim_rgb : undefined}
      colorName={c.name}
      colorId={c.id}
      key={c.name}
      handleSelect={null}
    />
  );
};

const StoreProductCardList: React.FC<StoreProductsListProps> = ({
  products,
  mmsProducts
}: StoreProductsListProps): ReactElement => {
  const colorMap = useAppSelector(selectProductColorMap);

  return (
    <Box className="storeProductCardBox">
      {products?.map(product => {
        return (
          <Card key={product.id}>
            <CardMedia component="img" image={product.imageUrl} />
            <CardHeader title={product.name} />
            <CardContent>{`${formatCurrency(
              Number(product.price)
            )} each`}</CardContent>
            <CardActions>
              {mmsProducts && colorMap[product.id].map(productColors)}
            </CardActions>
          </Card>
        );
      })}
    </Box>
  );
};

export default StoreProductCardList;
